<template>
    <div class="duty-approval">
        <div v-if="!!data.data && !!data.data.length" class="table-responsive">
            <table class="table table-sm table-bordered table-hover">
                <thead class="thead-orange">
                    <tr>
                        <th>Cliente</th>
                        <th>Nombre</th>
                        <th>Descripción</th>
                        <th>General / Especifica</th>
                        <th>Fecha de creación</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="duty in data.data">
                        <td>{{duty.client.name}}</td>
                        <td>{{duty.name}}</td>
                        <td>{{duty.description}}</td>
                        <td>{{!!duty.general?'General':'Especifica'}}</td>
                        <td>{{duty.created_at | datetime}}</td>
                        <td>
                            <div class="d-flex">
                                <div class="px-1">
                                    <button class="btn btn-primary" :disabled="inProgress" @click="onEdit(duty)"><i class="fa fa-edit"></i></button>
                                </div>
                                <div class="px-1">
                                    <button class="btn btn-success" :disabled="inProgress" @click="onApprove(duty)"><i class="fa fa-check"></i></button>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <app-paginator 
                :current-page="data.current_page"
                :last-page="data.last_page"
                :from="data.from"
                :to="data.to"
                :total="data.total"
                :per-page="data.per_page"
                :on-change-page="onChangePage"
            />
        </div>
        <div v-else class="alert alert-info">
            No hay consignas por aprobar
        </div>
    </div>
</template>
<script>
    import Paginator from '../../../UI/Controls/Paginator/Paginator.vue';
    export default {
        components: {
            appPaginator: Paginator
        },
        props: {
            data: {
                type: Object,
                required: true
            },
            onEdit: {
                type: Function,
                required: true
            },
            onApprove: {
                type: Function,
                required: true
            },
            onChangePage: {
                type: Function,
                required: true
            }
        }
    }
</script>